export default __webpack_public_path__ + "static/media/wegovy-twist-on-needle.00606495.mp4";